import { useState } from "react"
import { Input } from "./ui/shadcn/input"
import { Textarea } from "./ui/shadcn/textarea"
import FilePicker from "./ui/FilePicker"

export default function EpisodeEditor({ defaultValue, onChange }) {
    const [episode, setEpisode] = useState(defaultValue || {
        name: 'New Episode',
        description: ''
    })

    const handleChange = (e) => {
        const newEpisode = {...episode, [e.target.name]: e.target.value}
        setEpisode(newEpisode)
        if(onChange) onChange(newEpisode)
    }

    const handleFileChange = (file) => {
        const newEpisode = {...episode, thumbnailFile: file}
        setEpisode(newEpisode)
        if(onChange) onChange(newEpisode)
    }

    return (
        <div className='flex flex-col gap-4 w-full p-4'>
            <div className='flex flex-col gap-2'>
                <label htmlFor="name" className='text-xs text-secondary-foreground'>Name</label>
                <Input name='name' defaultValue={episode.name} onChange={handleChange} />
            </div>
            <div className='flex flex-col gap-2'>
                <label className='text-xs text-secondary-foreground'>Thumbnail</label>
                <FilePicker className='w-full aspect-video' accept='image/*' type='image' name='thumbnailFile' preview={episode.thumbnail_url} onChange={handleFileChange}/>
            </div>
            <div className='flex flex-col gap-2'>
                <label htmlFor="description" className='text-xs text-secondary-foreground'>Description</label>
                <Textarea name='description' defaultValue={episode.description} onChange={handleChange} />
            </div>
        </div>
    )
}